import { Component, OnInit } from '@angular/core';
import {FormGroup,FormBuilder,Validators,FormArray} from '@angular/forms';

@Component({
  selector: 'guia-telefonica',
  template: `
    <p>
      guia-telefonica works!
    </p>
  `,
  styles: []
})
export class GuiaTelefonicaComponent implements OnInit {

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    
  }

  getTelefono(){
    return this.fb.group({
      tipo:[null],
      numero:[null],
      referencia:[]
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/guia-telefonica.component.ts